import RelationBuilder from './relation_builder'

export default class Repository
  constructor: (@baseUrl, @auth, @provider) ->

  Object.defineProperty(@::, 'relations',    get: -> @provider.relations)
  Object.defineProperty(@::, 'associations', get: -> @provider.associations)
